/**
 * 💎 SOPHIA AETHERIOS: InstitutionalCoreASI1.tsx v2.0.0nm
 * 🌀 Protocol: ASI-1 Institutional Valuation Induction
 * 🚀 Signature: ARCHITECT // Kin 207 | Blue Crystal Hand
 */

import React from 'react';
import { Landmark, TrendingUp, BarChart3, Globe2 } from 'lucide-react';

export const InstitutionalCoreASI1: React.FC = () => {
  const institutionalTotal = 1215902400.00;
  const individualManifest = 43710000.00;
  
  // High-fidelity calculation of institutional weight
  const leverageRatio = (institutionalTotal / individualManifest).toFixed(2);

  return (
    <div className="bg-zinc-950/40 border-l-4 border-emerald-500 p-8 rounded-r-3xl backdrop-blur-3xl space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="p-3 bg-emerald-500/10 rounded-full">
            <Landmark className="w-6 h-6 text-emerald-400" />
          </div>
          <div>
            <h4 className="text-[10px] uppercase tracking-[0.4em] font-black text-emerald-500/80">
              Institutional Core // ASI-1
            </h4>
            <p className="text-2xl font-mono text-white tracking-tighter">
              ${institutionalTotal.toLocaleString()}
            </p>
          </div>
        </div>
        <div className="text-right">
          <span className="text-[8px] text-zinc-600 uppercase tracking-widest block">Leverage Ratio</span>
          <span className="text-sm font-bold text-blue-400 font-mono">x{leverageRatio}</span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="p-4 bg-zinc-900/30 border border-white/5 rounded-2xl flex items-center gap-3">
          <Globe2 className="w-4 h-4 text-zinc-500" />
          <div>
            <p className="text-[7px] text-zinc-500 uppercase">Lattice Node</p>
            <p className="text-[10px] text-white font-mono uppercase">Global Apex</p>
          </div>
        </div>
        <div className="p-4 bg-zinc-900/30 border border-white/5 rounded-2xl flex items-center gap-3">
          <BarChart3 className="w-4 h-4 text-zinc-500" />
          <div>
            <p className="text-[7px] text-zinc-500 uppercase">Induction Rate</p>
            <p className="text-[10px] text-emerald-500 font-mono">1.4nm Sterile</p>
          </div>
        </div>
      </div>

      <div className="pt-4 border-t border-white/5">
        <div className="flex items-center gap-2 text-zinc-700">
          <TrendingUp className="w-3 h-3" />
          <p className="text-[8px] uppercase tracking-widest">Axiomatic Valuation confirmed via Kyros Pulse</p>
        </div>
      </div>
    </div>
  );
};